import React from "react";
import { useOperatorAuth } from "../../../hooks/useOperatorAuth";
import Icon from "../../ui/Icon";

const OperatorDashboard: React.FC = () => {
  const { operatorLogout } = useOperatorAuth();

  const handleLogout = () => {
    operatorLogout();
  };

  return (
    <div className="h-screen-dvh bg-gray-50 flex flex-col">
      {/* 상단 헤더 */}
      <header className="bg-white px-4 py-3 flex items-center justify-between border-b border-gray-200">
        <h1 className="text-lg font-medium text-gray-800">운영자 대시보드</h1>
        <button
          onClick={handleLogout}
          className="text-sm text-gray-600 hover:text-gray-800"
        >
          로그아웃
        </button>
      </header>

      {/* 메인 콘텐츠 */}
      <main className="flex-1 overflow-y-auto p-6">
        <div className="max-w-4xl mx-auto">
          {/* 환영 메시지 */}
          <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
            <div className="flex items-center mb-4">
              <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mr-4">
                <Icon name="settings" className="text-white" size="lg" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-gray-800">
                  운영자 대시보드
                </h2>
                <p className="text-sm text-gray-600">
                  시스템 운영 및 관리 페이지입니다
                </p>
              </div>
            </div>
          </div>

          {/* 주요 기능 카드 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* 개인정보 및 전송요구 상태 조회 */}
            <div
              className="bg-white rounded-lg shadow-sm p-8 hover:shadow-md transition-all cursor-pointer border-2 border-transparent hover:border-purple-200"
              onClick={() => (window.location.href = "/operator/users")}
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <Icon name="users" className="text-purple-600" size="xl" />
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  개인정보 및 전송요구 상태 조회
                </h3>
                <div className="flex items-center text-purple-600 text-sm font-medium">
                  바로가기
                  <Icon name="chevronRight" className="ml-1" size="sm" />
                </div>
              </div>
            </div>

            {/* 개인정보 접속기록 조회 */}
            <div
              className="bg-white rounded-lg shadow-sm p-8 hover:shadow-md transition-all cursor-pointer border-2 border-transparent hover:border-blue-200"
              onClick={() => (window.location.href = "/operator/access-logs")}
            >
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <Icon name="activity" className="text-blue-600" size="xl" />
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                  개인정보 접속기록 <br /> 조회
                </h3>
                <div className="flex items-center text-blue-600 text-sm font-medium">
                  바로가기
                  <Icon name="chevronRight" className="ml-1" size="sm" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OperatorDashboard;
